import { render, staticRenderFns } from "./SkeletonSquare.vue?vue&type=template&id=75d1a20e&scoped=true"
import script from "./SkeletonSquare.vue?vue&type=script&lang=js"
export * from "./SkeletonSquare.vue?vue&type=script&lang=js"
import style0 from "./SkeletonSquare.vue?vue&type=style&index=0&id=75d1a20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d1a20e",
  null
  
)

export default component.exports